module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "works-picture"
  }, [_c('div', {
    staticClass: "works border-bottom"
  }, [_c('div', {
    staticClass: "works-wrapper border-right upload-logo"
  }, [_c('div', {
    staticClass: "upload-logo-box"
  }, [_c('div', {
    staticClass: "upload-works-detail"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.logoImg
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.images.logoUploaded),
      expression: "!images.logoUploaded"
    }],
    staticClass: "upload-logo-file"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdited && !_vm.images.logoUploading),
      expression: "isEdited && !images.logoUploading"
    }],
    staticClass: "upload-mask",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../images/personal_center/icon-img.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.logoUploading),
      expression: "images.logoUploading"
    }],
    staticClass: "mask-loading"
  }, [_vm._m(1)]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "logo",
      "value": "",
      "accept": "image/*",
      "title": "更换图片"
    },
    on: {
      "change": function($event) {
        return _vm.imgOnChange($event, 'logo')
      }
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("上传作品LOGO")]), _vm._v(" "), _c('p', [_vm._v("图片尺寸：88 x 88px ")]), _vm._v(" "), _c('p', [_vm._v("图片格式：JPG / PNG ")]), _vm._v(" "), _c('p', [_vm._v("图片用途：图片将用于展示在用的蓝鲸平台的桌面上，以及开发者中心的APP LOGO中。")])]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper"
  }, [_c('div', {
    staticClass: "product-img",
    on: {
      "mouseenter": _vm.showCover,
      "mouseleave": _vm.hideCover
    }
  }, [_c('div', {
    staticClass: "upload-works-detail"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.coverImg
    }
  }), _vm._v(" "), (_vm.images.coverObj) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.coverIndex === 1),
      expression: "images.coverIndex === 1"
    }],
    staticClass: "bk-icon icon-error",
    on: {
      "click": function($event) {
        return _vm.closeImg($event, 'cover')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.images.coverObj) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.coverIndex === 1),
      expression: "images.coverIndex === 1"
    }],
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.images.coverObj.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.images.coverUploaded),
      expression: "!images.coverUploaded"
    }],
    staticClass: "mask"
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdited && !_vm.images.coverUploading),
      expression: "isEdited && !images.coverUploading"
    }],
    staticClass: "upload-mask"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../images/personal_center/icon-img.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                    修改封面图片\n                  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.coverUploading),
      expression: "images.coverUploading"
    }],
    staticClass: "mask-loading"
  }, [_vm._m(3)]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "cover",
      "value": "",
      "accept": "image/*",
      "title": "更换图片"
    },
    on: {
      "change": function($event) {
        return _vm.imgOnChange($event, 'cover')
      }
    }
  })]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "works"
  }, [_c('div', {
    staticClass: "works-wrapper upload-works"
  }, [_c('ul', {
    staticClass: "upload-works-list"
  }, _vm._l((_vm.workList), function(item, index) {
    return _c('li', {
      on: {
        "mouseenter": function($event) {
          return _vm.showCurWorks(item, index)
        },
        "mouseleave": _vm.hideCurWorks
      }
    }, [_c('div', {
      staticClass: "upload-works-detail"
    }, [_c('img', {
      attrs: {
        "src": _vm.images[item.obj + 'Img']
      }
    }), _vm._v(" "), (_vm.images[item.obj + 'Obj']) ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.images.avatarIndex),
        expression: "index === images.avatarIndex"
      }],
      staticClass: "bk-icon icon-error",
      on: {
        "click": function($event) {
          return _vm.closeImg($event, item.obj)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.images[item.obj + 'Obj']) ? _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.images.avatarIndex),
        expression: "index === images.avatarIndex"
      }],
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.images[item.obj + 'Obj'].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.images[item.obj + 'Img']),
        expression: "!images[item.obj+'Img']"
      }],
      staticClass: "mask"
    }, [_vm._m(5, true)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isEdited && !_vm.images[item.obj + 'Uploading']),
        expression: "isEdited && !images[item.obj+'Uploading']"
      }],
      staticClass: "upload-mask"
    }, [_c('img', {
      attrs: {
        "src": require("../../../../images/personal_center/icon-img.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v("\n                        修改截图图片\n                      ")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.images[item.obj + 'Uploading']),
        expression: "images[item.obj+'Uploading']"
      }],
      staticClass: "mask-loading"
    }, [_vm._m(6, true)]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "name": "avatar",
        "value": "",
        "accept": "image/*",
        "title": "更换图片"
      },
      on: {
        "change": function($event) {
          return _vm.imgOnChange($event, item.obj)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('h2', [_vm._v("上传作品截图")]), _vm._v(" "), _c('p', [_vm._v("图片像素：868 x 488px ")]), _vm._v(" "), _c('p', [_vm._v("图片格式：JPG / PNG ")]), _vm._v(" "), _c('p', [_vm._v("图片用途：图片将用于显示在应用详情介绍页面中，目前最多仅支持上次3张；您可以上次应用系统的页面截图，亦或者产品宣传图片皆可。一张富有说服力的应用介绍图片能够帮助用户更快的了解你的作品，请务必要谨慎筛选。")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images.isShowImageEditor),
      expression: "images.isShowImageEditor"
    }],
    staticClass: "personal-pops"
  }, [_c('div', {
    staticClass: "pops-content"
  }, [_c('h4', [_vm._v("\n                " + _vm._s(_vm.images.editImageTitle) + "剪裁\n                "), _c('a', {
    staticClass: "fr pops-close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeImageEditor
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../images/personal_center/pops-close.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "editor"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.imageWaitingForCrop,
      "alt": "",
      "id": "editor"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_vm._m(7), _vm._v(" "), _c('button', {
    staticClass: "confirm-image-editor",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.confirmCrop
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("选取"), _c('br'), _vm._v("图片")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-box"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "strip1 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip2 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip3 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip4 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip5 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip6 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip7 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip8 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip9 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip10 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip11 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip12 strip"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../images/personal_center/icon-img-gray.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            上传作品封面\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-box"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "strip1 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip2 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip3 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip4 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip5 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip6 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip7 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip8 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip9 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip10 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip11 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip12 strip"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            正在上传图片...\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artwork-cover"
  }, [_c('h2', [_vm._v("上传作品封面")]), _vm._v(" "), _c('p', [_vm._v("图片像素：285 x 160px ")]), _vm._v(" "), _c('p', [_vm._v("图片格式：JPG / PNG ")]), _vm._v(" "), _c('p', [_vm._v("图片用途：图片将用于官方首页或应用分类页的展示，精美的LOGO图可以大幅度提升作品对用户的注意力和吸引力，建议您精心挑选...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../images/personal_center/icon-img-gray.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                                上传作品截图\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-box"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "strip1 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip2 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip3 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip4 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip5 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip6 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip7 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip8 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip9 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip10 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip11 strip"
  }), _vm._v(" "), _c('div', {
    staticClass: "strip12 strip"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                                正在上传图片...\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "zoom",
      "data-options": "0.1",
      "title": "放大"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-zoom-in",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "zoom",
      "data-options": "-0.1",
      "title": "缩小"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-zoom-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "move",
      "data-options": "-10",
      "data-second-options": "0",
      "title": "左移"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "move",
      "data-options": "10",
      "data-second-options": "0",
      "title": "右移"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "move",
      "data-options": "0",
      "data-second-options": "-10",
      "title": "上移"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-up",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "data-type": "controller",
      "data-method": "move",
      "data-options": "0",
      "data-second-options": "10",
      "title": "下移"
    }
  }, [_c('span', {
    staticClass: "docs-tooltip"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-71be50fc!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works/common/works_pictures.vue
// module id = XxvB
// module chunks = 16